export default __webpack_public_path__ + "static/media/friends.547620e1.svg";